module.exports = __webpack_public_path__ + "media/images/japan/kaga_guide/kakusenkei-6d9aa3f96edf5f60524c115b04b2918e.jpg";